// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1etcb","info":"PatientInfo_info__Aop6k"};